import { Component, Input, OnInit, inject } from '@angular/core';
import { PayoutService } from '@shared/services/payout/payout.service';
import { AdminPayoutRequestHistoryEvent, PayoutRequestStatus } from 'thkee-common';
import { ProcessingDirective } from '../../../../../../../../../../thkee-common/src/lib/directives/processing.directive';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-payout-request-history',
    templateUrl: './payout-request-history.component.html',
    styleUrls: ['./payout-request-history.component.scss'],
    imports: [ProcessingDirective, DatePipe]
})
export class PayoutRequestHistoryComponent implements OnInit {
  private payoutService = inject(PayoutService);

  @Input() set requestId(requestId: number | undefined) {
    if (!requestId) {
      this.history = [];
      return;
    }

    this.getHistory(requestId!);
  };

  history?: AdminPayoutRequestHistoryEvent[];
  actionTitles: Record<PayoutRequestStatus, string> = {
    paid: 'Paid',
    processing: 'Processing',
    requested: 'Payout Request Created',
    deactivated: 'Payout Request Deactivated',
    ready: 'Payout Request Ready',
    failed: 'Payout Request Failed',
  }

  ngOnInit(): void {
  }

  private getHistory(id: number) {
    this.payoutService.getPayoutRequestHistory(id).subscribe(data => this.history = data)
  }
}
